import type { FallbackProps } from 'react-error-boundary';
import { LayoutDashboard, RefreshCw } from 'lucide-react';
import { Button } from '@/components/button/button';
import ErrorLayout from '@/components/layouts/error-layout/error-layout';
import { browserNavigate } from '@/utils/browser';
import { IS_APP_DEVELOPMENT } from '@/configs/app.config';

export default function AppError({ resetErrorBoundary, error }: FallbackProps) {
  return (
    <ErrorLayout
      title="An Error Occurred"
      description="An unexpected error occurred. Please try again or return to the dashboard."
    >
      {IS_APP_DEVELOPMENT && error instanceof Error && (
        <pre className="w-full max-h-40 overflow-auto break-all whitespace-pre-wrap rounded-lg bg-red-50 border border-destructive p-3 text-left text-xs text-destructive">
          <strong>{error.name}:</strong> {error.message}
          {error.stack && `\n\n${error.stack}`}
        </pre>
      )}
      <div className="flex items-center gap-3">
        <Button variant="outline" onClick={resetErrorBoundary}>
          <RefreshCw className="w-4 h-4" />
          Try Again
        </Button>
        <Button
          onClick={() => {
            browserNavigate('/');
            resetErrorBoundary();
          }}
        >
          <LayoutDashboard className="w-4 h-4" />
          Back to Dashboard
        </Button>
      </div>
    </ErrorLayout>
  );
}
